//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Work } from '@/models'

export default {
  computed: {
    work () {
      return this.quote.get('work')
    }
  },

  props: {
    quote: {
      type: Object,
      default: {

      }
    }
  },

  methods: {
    goToWork () {
      this.$router.push({
        name: 'work',
        params: {
          id: this.work.id
        }
      })
    },

    goToAuthor () {
      this.$router.push({
        name: 'author',
        params: {
          id: this.quote.get('author').id
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_quote/QuoteListItem.vue